import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { ComponentProps, ReactNode, Ref } from 'react';

import * as styles from './ImageDropbox.css';

// FA5 definitions share the renderer shape but have a different icon-name union.
export const MediaDropbox = ({
  onChange,
  type = 'image',
  icon = faCloudUploadAlt,
  children,
  short,
  inputRef,
  hasError,
  ...rest
}: {
  hasError?: boolean;
  onChange: (file: File | undefined) => void;
  type?: 'image' | 'video';
  icon?:
    | ComponentProps<typeof FontAwesomeIcon>['icon']
    | typeof faCloudUploadAlt;
  children?: ReactNode;
  short?: boolean;
  inputRef?: Ref<HTMLInputElement>;
}) => {
  return (
    <div
      className="h-full w-full relative rounded-lg flex flex-grow justify-center items-center cursor-pointer"
      style={{ border: `2px solid ${hasError ? 'red' : 'transparent'}` }}
    >
      <input
        className={styles.input}
        type="file"
        accept={type === 'image' ? 'image/*' : 'video/*'}
        onChange={(evt) => {
          onChange(evt.target.files?.[0]);
          evt.target.value = '';
        }}
        ref={inputRef}
        {...rest}
      />
      <div
        className={`flex ${
          short ? 'flex-row' : 'flex-col'
        } items-center leading-normal p-2.5`}
      >
        <FontAwesomeIcon
          icon={icon as ComponentProps<typeof FontAwesomeIcon>['icon']}
          className="text-2xl text-[#C5C8D2]"
        />
        <Typography
          variant="h1"
          className={`font-semibold ${
            short ? 'ml-[15px]' : 'mt-4'
          } mb-0 text-[16px] text-center text-gray-1`}
        >
          Drop or <span className="text-primary">browse</span>
        </Typography>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};
